<nz-form-item>
  <nz-form-control [nzValidateStatus]="convertErrorsNz[inputFormControl.status]">
    <input type="checkbox" id="reactive-checkbox-control" ngDefaultControl [class]="inputClass" [formControl]="asFormControl(inputFormControl)" />
    <label for="reactive-checkbox-control">{{label}}</label>
    <app-form-item-error [touched]="inputFormControl.touched" [errors]="inputFormControl.errors"></app-form-item-error>
  </nz-form-control>
</nz-form-item>
